import { cva } from 'class-variance-authority';
export { default as Badge } from './Badge.vue';
/**
 * Dot background colours. Used when the dot element is rendered (variant='outline').
 * Values reference CSS custom properties defined in styles/tokens/colors.css.
 */
export const badgeDotClasses = {
    default: 'bg-muted-foreground',
    success: 'bg-[var(--en-color-success)]',
    error: 'bg-[var(--en-color-danger)]',
    warning: 'bg-[var(--en-color-warning)]',
    info: 'bg-[var(--en-color-info)]',
    purple: 'bg-[var(--en-color-purple)]',
    grey: 'bg-[var(--en-color-grey)]',
    darkBlue: 'bg-[var(--en-color-dark-blue)]',
    lightGreen: 'bg-[var(--en-color-light-green)]',
};
/**
 * State keys derived from badgeDotClasses, single source of truth.
 */
const badgeStateDefinitions = Object.fromEntries(Object.keys(badgeDotClasses).map(k => [k, '']));
/**
 * Colored fills bg/text/border, outline keeps badge neutral (white pill + border).
 */
const badgeVariantDefinitions = {
    colored: '',
    outline: 'bg-white text-foreground border border-input',
};
// Heights and padding keep badges on a 4 px grid (1 rem = 16 px).
// h-7 = 28 px  |  h-6 = 24 px
const badgeSizeDefinitions = {
    default: 'h-7 px-2 text-sm',
    sm: 'h-6 px-1.5 text-sm',
};
export const badgeVariants = cva("inline-flex items-center gap-1.5 whitespace-nowrap rounded-md font-medium shadow-xs [&_svg]:pointer-events-none [&_svg:not([class*='size-'])]:size-3.5 shrink-0 [&_svg]:shrink-0", {
    variants: {
        state: badgeStateDefinitions,
        variant: badgeVariantDefinitions,
        size: badgeSizeDefinitions,
    },
    compoundVariants: [
        { variant: 'colored', state: 'default', class: 'bg-secondary text-secondary-foreground border border-input' },
        { variant: 'colored', state: 'success', class: 'bg-emerald-100 text-emerald-700 border border-emerald-300' },
        { variant: 'colored', state: 'error', class: 'bg-red-100 text-red-700 border border-red-300' },
        { variant: 'colored', state: 'warning', class: 'bg-orange-100 text-orange-700 border border-orange-300' },
        { variant: 'colored', state: 'info', class: 'bg-blue-100 text-sky-700 border border-blue-300' },
        { variant: 'colored', state: 'purple', class: 'bg-purple-100 text-purple-700 border border-purple-300' },
        { variant: 'colored', state: 'grey', class: 'bg-gray-100 text-gray-700 border border-gray-300' },
        { variant: 'colored', state: 'darkBlue', class: 'bg-slate-100 text-slate-700 border border-slate-300' },
        { variant: 'colored', state: 'lightGreen', class: 'bg-green-100 text-green-700 border border-green-300' },
    ],
    defaultVariants: {
        state: 'default',
        variant: 'colored',
        size: 'default',
    },
});
